const addDaysToUTCDate = (days) => {
    const date = new Date();
    date.setUTCDate(date.getUTCDate() + days);
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString().split('T')[0];
};

export default addDaysToUTCDate;